/* eslint-disable */

import { createApp } from "vue";
import App from "./App.vue";

import axios from "axios";
import handleError from "./Config/httpErrorHandler";
import { applyStoredAuthToAxios } from "./Api/auth";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
applyStoredAuthToAxios();

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    handleError(error);
    return Promise.reject(error);
  }
);

createApp(App).mount("#app");
